import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import { ScheduleCalendar } from '../../../../global/components/calendar/Calendar';
import { gEnums } from '../../../../global/enums/globalEnums';
import MenuSidebars from '../../../../global/sidebars/MenuSidebars';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { createScheduleTypes } from '../../cnr/reducers/CreateSportsReducer';
import { CreatePlayoffContext } from '../CreatePlayoff';
import { CreateSportsContext } from '../CreateSports';
import { CreateSportsSeasonContext } from '../CreateSeason';
import { useCreateSportsSeason } from 'projectSpecific/sports/useHelpers/useCreateSeasonal';
import { useSportsFilters } from 'projectSpecific/sports/useHelpers/useSportsFilters';
import { Button } from 'semantic-ui-react';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';

const sidebarType = 'createScheduleDates'

const CreateSectionDates = (props) => {

  const _asat = gEnums.availableSubActionTypes

  const { createScheduleType, menuDisplayType } = props ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_handlers, sportsSeason_state } = sportsSeasonContext ?? {}

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state, createSports_handlers } = createSportsContext ?? {}
  const { subActionType, sportsDetails, levels_info, mediaSeason } = createSports_state ?? {}
  const { year: sportsYears } = sportsDetails ?? {}

  // createSportsSeasonContext
  const createSportsSeasonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_state, createSportsSeason_handlers } = createSportsSeasonContext ?? {}
  const { getCurrent, getScheduleDatesInfo } = useCreateSportsSeason()
  const { sportsSeason_selected } = getCurrent()
  // const { sportsSeason_selected } = createSportsSeason_state ?? {}
  const { seasonals, matches } = sportsSeason_selected ?? {}
  const { teams } = seasonals ?? {}
  const { sectionDates: currentDates_schedule, sectionCounts: sectionTeamCounts } = seasonals ?? {}
  // const { sectionTeamCounts, scheduleDates_info } = seasonals_fluid ?? {}
  // const { currentDates: currentDates_schedule } = scheduleDates_info ?? {}

  const teamCounts = _.size(teams)
  // console.log('teams', _.size(teams))

  // createPlayoffContexts
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { playoff_info, playoffGroupKey } = createPlayoff_state ?? {}
  const { playoffLevelTeams, playoffDates_current, playoffLevel } = playoff_info ?? {}
  const { currentDates: currentDates_playoffs } = playoffDates_current ?? {}

  const { getLevelMatches, getSectionDates } = useSportsFilters()
  // const { levelMatches } = getLevelMatches({ matches })

  const sectionDates = useMemo(() => {
    const { sectionDates: sds } = getSectionDates({ matches })
    return sds
  }, [])

  // const zzz = getScheduleDatesInfo({ currentSectionCount: teamCounts, sectionDates }) /
  const _currentDates = createScheduleType === createScheduleTypes.season ? sectionDates : currentDates_playoffs

  // sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}
  const { setInit } = sidebar_handlers ?? {}

  const { ms_dataGroups } = sidebar_items ?? {}
  const { selected: selected_pg } = ms_dataGroups ?? {}
  const { item: item_pg } = selected_pg ?? {}

  const [levels, setLevels] = useState()
  const [selectedSection, setSelectedSection] = useState()

  const currentDates = sectionDates?.[selectedSection]


  useEffect(() => {
    let _sidebarSliderType = sidebarSliderTypes.labeled
    if (menuDisplayType && menuDisplayType !== gEnums.menuDisplayTypes.menuButtons) { _sidebarSliderType = sidebarSliderTypes.normal }
    switch (createScheduleType) {
      case createScheduleTypes.season:
        if (sectionTeamCounts) {
          console.log('sectionTeamCounts', sectionTeamCounts)
          setInit({
            smt: sidebarMenuTypes.one,
            items: _.isEmpty(sectionTeamCounts) ? [6, 7] : sectionTeamCounts,
            currents,
            as: 'dataGroups',
            sidebarSliderType: _sidebarSliderType,
          })
        }
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  // once
  useEffect(() => {
    if (playoffLevelTeams) {
      const _levels = Object.keys(playoffLevelTeams).sort().reverse()
      setLevels(_levels)
    }
    switch (createScheduleType) {
      case createScheduleTypes.season:
        const { existing } = levels_info ?? {}
        const _existing = _.filter(existing, { checked: true })
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    let _sidebarSliderType = sidebarSliderTypes.labeled
    if (menuDisplayType && menuDisplayType !== gEnums.menuDisplayTypes.menuButtons) { _sidebarSliderType = sidebarSliderTypes.normal }
    switch (createScheduleType) {
      case createScheduleTypes.playoff:
        if (playoffLevel) {
          setInit({
            smt: sidebarMenuTypes.one,
            items: [playoffLevel],
            currents,
            as: 'dataGroups',
            sidebarSliderType: _sidebarSliderType,
          })
        } else if (levels) {
          setInit({
            smt: sidebarMenuTypes.one,
            items: levels,
            currents,
            as: 'dataGroups',
            sidebarSliderType: _sidebarSliderType,
          })
        }
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [levels, playoffLevel]);

  // this happens when the level has changed?
  useEffect(() => {
    if (item_pg) {
      switch (createScheduleType) {
        case createScheduleTypes.playoff:
          const _playoffGroup = playoffLevelTeams[item_pg]
          createPlayoff_handlers.handleSet_playoffGroup(item_pg, _playoffGroup)
          // createPlayoff_handlers.handleAmmend_playoffDateGroup({ levelKey: item_pg })
          break;
        case createScheduleTypes.season:
          const seasonDateProps = { sectionTeamCount: item_pg }
          createSportsSeason_handlers.handleAmmend_seasonSectionDateGroup(seasonDateProps)
          break;
        default:
        // nothing
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [item_pg]);

  useEffect(() => {
    if (playoffGroupKey) {
      switch (createScheduleType) {
        case createScheduleTypes.playoff:
          createPlayoff_handlers.handleAmmend_playoffDateGroup()
          break;
        default:
        // nothing
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [playoffGroupKey]);

  const content = () => {
    switch (subActionType) {
      case _asat.createSeason:
      case _asat.createPlayoff:
        return <ScheduleCalendar
          subActionType={subActionType}
          createScheduleType={createScheduleType}
          currentDates={currentDates} />
      default:
        return <div>No Create Type</div>
    }
  }

  const header = () => {
    const btns = _.map(sectionDates, (tc, tck) => (
      <Button className={selectedSection === tck ? 'btn-sel' : null} color={selectedSection === tck ? 'blue' : 'black'} onClick={() => setSelectedSection(tck)}>{tck}</Button>
    ))
    return <Button.Group size='mini'>{btns}</Button.Group>
  }

  return <Wrapper
    header={header()}
    content={content()}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode', header: 'nob' }}
  ></Wrapper >


  // const menuSidebars = () => sidebar_items ? <MenuSidebars
  //   sidebarType={sidebarType}
  //   sidebar_items={sidebar_items}
  //   sidebar_handlers={sidebar_handlers}
  //   content={content()}
  //   dimmed={dimmed}
  // /> : <div>NO SIDEBRE</div>

  // return menuSidebars()

  // switch (createScheduleType) {
  //   case createScheduleTypes.playoff:
  //     if (playoffLevelTeams && levels && ms_dataGroups && ms_dataGroups.items) {
  //       if (createScheduleType === createScheduleTypes.playoff) {
  //         return content()
  //       } else {
  //         return menuSidebars()
  //       }
  //     } else {
  //       return <div>---</div>
  //     }
  //   case createScheduleTypes.season:
  //     if (ms_dataGroups && ms_dataGroups.items) {
  //       return menuSidebars()
  //     } else {
  //       return <div>---</div>
  //     }
  //   default:
  //     return <div>---</div>
  // }
}

export default CreateSectionDates